(ns ycweb.components.flow
  (:require
   [rum.core :as rum]
   [ycweb.components.transitions :as t]
   [ycweb.components.toaster :as toaster]
   [ycweb.util.core :as u]
   [ycweb.components.common :as cmn]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.datepicker :as datepicker]
   [ycweb.components.history :as history]
   [ycweb.app.pos.dev :as dev]))



;; Barcode handling
(defmulti barcode-dispatch-modal (fn [modal-key app-atom scan] modal-key))
(defmethod barcode-dispatch-modal :default [modal-key app-atom _]
  (toaster/open-toast app-atom :error "Close popup before scanning" {:closetime 2000}))

(defmulti barcode-dispatch-screen (fn [screen-key app-atom scan] screen-key))
(defmethod barcode-dispatch-screen :default [modal-key app-atom _]
  (toaster/open-toast app-atom :error "Can't scan while on this screen" {:closetime 1000}))


(defn barcode-dispatch [app-atom scan]
  (let [modal-key (grid/modal-key app-atom)]
    (if modal-key
      (barcode-dispatch-modal modal-key app-atom scan)
      (barcode-dispatch-screen (-> @app-atom :page :screen) app-atom scan))))


(defn back-button [app-atom]
  (when (not= :lock (get-in @app-atom [:page :screen]))
    (t/transition-prev app-atom)))

;; Global flow control....

(defmulti render-screen (fn [app-atom screen] screen))

(defn page-not-found-content
  "The site's 404 copy. Callers supply their own wrapper."
  []
  [:div.yc-intro-text
   (headings/heading "Oh dear, something's gone wrong" {:type :h1 :size :large :center true})

   [:p.yc-paragraph.u-text-center
    "We tried our best but we can't find the page you're after (aka a 404 error).
                 We recommend you head back to our "
    [:a
     {:class (u/bem :text-link [:muted])
      :href "/index.htm"}
     "homepage"]
    " or "
    [:a.js-mfp-open-popup-search
     {:class (u/bem :text-link [:muted])
      :href "#"
      :data-popup-src "js-main-search-popup"
      :data-popup-focus-id "searchstr"}
     "search"]
    " to find what you were looking for."]
   [:div.u-block-center.u-max-width-240
    (buttons/button-web "Return to Homepage"
      {:href "index.htm"
       :style :primary
       :full true})]])

(defmethod render-screen :default [app-atom screen]
  [:div.section.u-text-center
   (cond
     (= "web" (cmn/curact app-atom [:app :app]))
     ;;todo - should we have a log of these being hit? especially as we port things, how do we pick up missed pages?
     [:div
      {:class (u/bem :yc-page-content [:standard])}
      [:div
       {:class (u/bem :yc-section [:medium])}
       (page-not-found-content)]]

     :else
     [:div
      (str "Unsupported screen:" screen)
      [:p
       (buttons/button
         "Fix" #(grid/dispatch-action app-atom :state/reset {}) {})]])])

(rum/defc render-state < rum/reactive
  [app-atom]

  (let [screen-atom (rum/cursor-in app-atom [:page :screen])
        screen (rum/react screen-atom)]
    (render-screen app-atom screen)))


(rum/defc flow [app-atom dev-modals?]
  [:div
   (render-state app-atom)

   (grid/modal-background app-atom)
   (grid/modal app-atom false)
   (grid/modal app-atom true)

   (datepicker/datepicker-modal-background app-atom)
   (datepicker/datepicker-modal app-atom)

   (toaster/progress-toaster-overlay app-atom)
   (toaster/progress-toaster app-atom)

   (cmn/profile-view)
   (when dev-modals?
     (dev/dev-modals app-atom))])

(defonce barcode-collector (atom nil))

(defn key-listener [app-atom refresh-fn e]
  ;; Start dev console..
  #?(:cljs
     (let [collector @barcode-collector]
       (when-not (cmn/override-global-keys?)
         (cond
           (and collector (= (.-keyCode e) 13))
           (do
             (reset! barcode-collector nil)
             (barcode-dispatch app-atom collector))

           collector
           (swap! barcode-collector str (.fromCharCode js/String (.-keyCode e)))

           ; Tilde
           (and (= (.-keyCode e) 192) (.-shiftKey e))
           (reset! barcode-collector "")

           ; Backtick
           (= (.-keyCode e) 192)
           (do
             (dev/open-modal (dev/dev-menu app-atom))
             (.preventDefault e))


           ; Left
           (and (= (.-keyCode e) 37) (.-shiftKey e) (.-ctrlKey e))
           (do
             (history/history-back history/app-snapshot app-atom)
             (refresh-fn))

           ; Right
           (and (= (.-keyCode e) 39) (.-shiftKey e) (.-ctrlKey e))
           (do
             (history/history-forward history/app-snapshot app-atom)
             (refresh-fn))

           (= (.-keyCode e) 27)
           (let [dev-closed? (dev/close-modal)
                 {:keys [config] :as modal-state} (cmn/curact app-atom :modal)

                 {:keys [requires-action cancel-key]}
                 (when (:type modal-state)
                   (grid/modal-config app-atom config (:type modal-state)))]

             (cond
               (and cancel-key (not requires-action))
               (grid/dispatch-modal-action app-atom cancel-key)

               (and (not dev-closed?) (not requires-action))
               (grid/close-modal app-atom)))

           (= (.-keyCode e) 13)
           (dev/dispatch-enter #(barcode-dispatch app-atom %))))))

  #_(println (.-keyCode e)))


(defn setup-keys [app-atom refresh-fn]
  #_(println "Setting up key-listeners, for real")
  #?(:cljs
     (.addEventListener js/document "keydown" #(key-listener app-atom refresh-fn %))))



